import { Controller } from "@hotwired/stimulus";
import {
  computePosition,
  flip,
  shift,
  offset,
  autoUpdate,
} from "@floating-ui/dom";

export default class extends Controller {
  static targets = ["content", "trigger"];
  static values = {
    show: { type: Boolean, default: false },
    placement: { type: String, default: "top" },
    offset: { type: Number, default: 4 },
  };

  connect() {
    this.updatePosition();
  }

  show() {
    this.showValue = true;
  }

  hide() {
    this.showValue = false;
  }

  toggle() {
    this.showValue = !this.showValue;
  }

  showValueChanged(state, _) {
    this.contentTarget.dataset.state = state ? "open" : "closed";

    if (state) {
      this.cleanupAutoUpdate = autoUpdate(
        this.triggerTarget,
        this.contentTarget,
        this.updatePosition,
      );
    } else {
      if (this.cleanupAutoUpdate) {
        this.cleanupAutoUpdate();
      }
    }
  }

  updatePosition = () => {
    computePosition(this.triggerTarget, this.contentTarget, {
      placement: this.placementValue,
      middleware: [
        offset(this.offsetValue),
        flip(),
        shift((state) => ({ padding: state.rects.reference.width })),
      ],
    }).then(({ x, y }) => {
      this.contentTarget.style.transform = `translate(${this.#roundByDPR(x)}px,${this.#roundByDPR(y)}px)`;
    });
  };

  #roundByDPR = (value) => {
    const dpr = window.devicePixelRatio || 1;
    return Math.round(value * dpr) / dpr;
  };
}
